export const operationFiatRoutes = [
  {
    path: "buy",
    name: "buy",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.perfectMoney.buy"
    },
    component: () =>
      import(
        /* webpackChunkName: "Buy" */ "@/components/PerfectMoney/Buy/index"
      )
  },
  {
    path: "sell",
    name: "sell",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.perfectMoney.sell"
    },
    component: () =>
      import(
        /* webpackChunkName: "Sell" */ "@/components/PerfectMoney/Sell/index"
      )
  }
];
